import React, { FC, useRef } from 'react'
import { MiniPopup } from '@components/Popup'
import * as Icons from '@components/Icons'
import { QuestionForm } from './QuestionForm'
import {
  Title,
  ArticleList,
  Article,
  ArticleText,
  Footer,
} from './LeadgenPopup.elements'

export type LeadgenFormData = {
  articles: {
    icon: string
    text: string
  }[]
  footer: string
  questions: QuestionDataInput[]
  title: string
  buttonText?: string
}

type Props = {
  answersPreset: Record<string, any>
  expandTitle?: boolean
  formData: LeadgenFormData
  onClose: () => void
  onSubmit: (answers: Record<string, any>, product?: string) => Promise<boolean>
  onPartialChange?: (answers: Record<string, any>) => void
  forceOptionalFields?: boolean
}

export const LeadgenPopup: FC<Props> = ({
  answersPreset,
  onClose,
  onSubmit,
  onPartialChange,
  expandTitle,
  forceOptionalFields,
  formData: {
    questions,
    title,
    articles,
    footer,
    buttonText,
  }
}) => {
  const popupRef = useRef<MiniPopup>(null)

  const handleClose = () => {
    const { current } = popupRef
    current && current.close()
  }

  const handleSubmit = (answers: Record<string, any>): Promise<boolean> => {
    const promise = onSubmit(answers)
    promise.then((continueFlow: boolean) => {
      continueFlow && handleClose()
    })

    return promise
  }

  return (
    <MiniPopup
      onClose={onClose}
      ref={popupRef}
    >
      <Title
        expand={!!expandTitle}
        dangerouslySetInnerHTML={{ __html: title }}
      />

      <ArticleList>
        {articles.map(({ icon, text }) => {
          const Icon = Icons[icon] || Icons.PiggyBankIcon
          return (
            <Article key={icon}>
              <Icon />
              <ArticleText dangerouslySetInnerHTML={{ __html: text }} />
            </Article>
          )
        })}
      </ArticleList>

      <QuestionForm
        answersPreset={answersPreset}
        onSubmit={handleSubmit}
        onPartialChange={onPartialChange}
        questions={questions}
        buttonText={buttonText}
        forceOptionalFields={forceOptionalFields}
      />

      <Footer dangerouslySetInnerHTML={{ __html: footer }} />
    </MiniPopup>
  )
}
